import { render } from "./ClaimsInsightComponent.vue?vue&type=template&id=8db458e6&scoped=true"
import script from "./ClaimsInsightComponent.vue?vue&type=script&lang=js"
export * from "./ClaimsInsightComponent.vue?vue&type=script&lang=js"

import "./ClaimsInsightComponent.vue?vue&type=style&index=0&id=8db458e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db458e6"]])

export default __exports__